// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-share{padding-left:0;list-style:none;display:flex;font-size:.875rem}.list-share li+li{margin-left:1rem}.btn-facebook{color:#3b5998;border-color:#3b5998}.btn-whatsapp{color:#25d366;border-color:#25d366}.btn-twitter{color:#1da1f2;border-color:#1da1f2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
